import { firebase } from "@firebase/app";
import "@firebase/firestore";
import "@firebase/functions";

/* remember to do firebase use staging */

const env = "staging";

const firebaseApp = firebase.initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  projectId: "virtual-house-pro",
});

const stageApp = firebase.initializeApp(
  {
    apiKey: process.env.VUE_APP_STAGE_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_STAGE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_STAGE_FIREBASE_DATABASE_URL,
    storageBucket: process.env.VUE_APP_STAGE_STORAGE_BUCKET,
    projectId: "virtual-house-pro-staging",
  },
  "staging"
);

export const db =
  env === "staging" ? firebaseApp.firestore() : stageApp.firestore();
export const functions =
  env === "staging" ? firebaseApp.functions() : stageApp.functions();
